// Styles here will override Bulma styles
import { css } from '@emotion/core';

export const footerStyled = css`
  text-align: center;
  background-color: #f9fafe;
  color: #080b2d;
  padding: 3rem 1.5rem;
  position: relative;
  left: 0;
  bottom: 0;
  min-height: 595px;
  overflow: hidden;
  z-index: 1000;

  p {
    color: #545372;
    font-family: 'WorkSans-Regular', 'Helvetica', 'sans-serif';
    font-size: 16px;
    font-weight: 500;
    line-height: 36px;
  }

  ul {
    list-style: none;
    text-align: left;

    a {
      color: #545372;
      font-family: 'WorkSans-Regular', 'Helvetica', 'sans-serif';
      font-weight: 200;
      text-decoration: none;

      :hover {
        color: #080b2d !important;
      }
    }
  }
`;

export const footerColumnsStyled = css`
  max-width: 1200px;
  margin: 0 auto;

  :last-of-type {
    border-top: 1px solid rgba(8, 11, 45, 0.2);
    padding-top: 20px;
  }
`;
